import React, { ReactNode } from 'react'

import styled from '@emotion/styled'

import { Colors, getColor } from '../theme/colors'

export type HeaderVariants =
  | 'big-money'
  | 'header-1'
  | 'header-2'
  | 'header-3'
  | 'header-4'
  | 'medium-title'
  | 'small-title'
  | 'secondary-label'

export type HeaderProps = {
  children?: ReactNode
  variant?: HeaderVariants
  as?: React.ElementType
  color?: Colors
  style?: React.CSSProperties
  id?: string
}

const Header = styled.span<HeaderProps>`
  display: block;
  font-family: 'cash-market-rounded';

  color: ${({ theme, color, variant }) => {
    if (color) return getColor(color)
    if (variant === 'secondary-label') return theme.colors.secondaryLabel // TODO: find all "secondary-label" Headers and either move them towards a Text/Typography component, or set their color="secondary-label", then delete this line
    return theme.colors.label
  }};

  ${props => {
    switch (props.variant) {
      case 'header-1':
        return props.theme.typography.header1
      case 'header-2':
        return props.theme.typography.header2
      case 'header-3':
        return props.theme.typography.pageTitle
      case 'header-4':
        return props.theme.typography.secondaryTitle
      case 'big-money':
        return props.theme.typography.bigMoney
      case 'medium-title':
        return props.theme.typography.mainTitle
      case 'small-title':
        return props.theme.typography.smallTitle
      case 'secondary-label':
        return props.theme.typography.secondaryLabel
      default:
        return
    }
  }}
`

const CustomHeader = (props: HeaderProps) => {
  if (props.variant && props.variant.startsWith('header')) {
    switch (props.variant) {
      case 'header-1':
        return (
          <Header as="h1" {...props}>
            {props.children}
          </Header>
        )
      case 'header-2':
        return (
          <Header as="h2" {...props}>
            {props.children}
          </Header>
        )
      case 'header-3':
        return (
          <Header as="h3" {...props}>
            {props.children}
          </Header>
        )
      case 'header-4':
        return (
          <Header as="h4" {...props}>
            {props.children}
          </Header>
        )
    }
  }
  return <Header {...props}>{props.children}</Header>
}

export default CustomHeader
